export default {
  donor: {}
};
